import { GET_LEADS_MOT_HISTORY_REQUEST, GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS, GET_LEADS_MOT_HISTORY_REQUEST_FAILURE } from '../constants/cap.constants';

export const getLeadsMotHistoryRequest = bike_details => ({ type: GET_LEADS_MOT_HISTORY_REQUEST, bike_details });
export const getLeadsMotHistoryRequestSuccess = payload => ({ type: GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS, payload });
export const getLeadsMotHistoryRequestFailure = error => ({ type: GET_LEADS_MOT_HISTORY_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_leads_mot_history.actions.js